import axios from 'axios';

const unsubscribeFromBuyerShowings = async (dashboardId: string) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/buyer_subscription`,
    method: 'delete' as const,
  };

  await axios.request<{ id: string }>(config);
};

export default unsubscribeFromBuyerShowings;
